/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import SelectWithSearch from "../../../components/selectWithSearch";
import axios from "../../../lib/api";

import { mapBranchesToUI, mapAdminsToUi } from "../mapToUi";

const ASSIGNEMENT_TYPE = [
    { value: "managerial", label: "Managerial Assignee" },
    { value: "on_ground", label: "On-ground Operations Assignee" },
];

const Container = styled.div``;

const Top = styled.div`
    max-width: 50%;
`;

const Bottom = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const BranchesForm = styled.div`
    width: 50%;
`;

const TagsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;
    overflow-y: scroll;
    max-height: 100px;
    flex-wrap: wrap;
    margin-left: 10px;
    max-width: 50%;
    overflow-x: hidden;
    justify-content: flex-end;
`;

const Tag = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    background: #e9f6ff;
    padding: 9px 14px;
    border-radius: 20px;
    font-weight: 700;
    font-size: 14px;
    color: #006bb4;
    cursor: pointer;
    width: auto;
    justify-content: space-evenly;

    svg {
        width: 15px;
        display: flex;
        justify-content: space-around;
    }
`;

const Error = styled.p`
    margin: 10px 0;
    color: red;
`;

function AssignAdmins({
    id,
    selectedAdmin,
    setSelectedAdmin,
    assignementType,
    setAssignementType,
    selectedBranches,
    setSelectedBranches,
    error,
    disableAdminSelect,
}) {
    const [allAdmins, setAllAdmins] = useState([]);
    const [allBranches, setAllBranches] = useState([]);

    const fetchAdmins = async (filter) => {
        const data = await axios.get("/admin-users", {
            params: {
                ...(filter && { "filter[q]": filter }),
            },
        });
        setAllAdmins(mapAdminsToUi(data.entities.adminUsers));
        return mapAdminsToUi(data.entities.adminUsers);
    };

    const fetchBranches = async (filter) => {
        const data = await axios.get("/branches", {
            params: {
                "filter[organizationId]": id,
                ...(filter && { "filter[q]": filter }),
            },
        });
        setAllBranches(mapBranchesToUI(data.entities.branches));
        return mapBranchesToUI(data.entities.branches);
    };

    const handleAssignmentType = (type) => {
        if (type?.value === "managerial") {
            setAssignementType(type);
            setSelectedBranches([]);
        } else {
            setAssignementType(type);
        }
    };

    const handleRemoveBranch = (branchToRemove) => {
        setSelectedBranches((prev) => prev.filter((branch) => branch !== branchToRemove));
    };

    useEffect(() => {
        fetchAdmins();
        fetchBranches();
    }, []);

    return (
        <Container>
            <Top>
                <SelectWithSearch
                    options={allAdmins}
                    value={selectedAdmin}
                    name="selectAdmin"
                    label="Select Admin"
                    placeholder="Select The Section.."
                    handleChange={(value) => setSelectedAdmin(value)}
                    handleFilter={(filter) => fetchAdmins(filter)}
                    isEditable
                    disable={disableAdminSelect}
                />
                <SelectWithSearch
                    options={ASSIGNEMENT_TYPE}
                    value={assignementType}
                    name="assignementType"
                    label="Assignement Type"
                    placeholder="Select Assignement type..."
                    handleChange={handleAssignmentType}
                    isEditable
                />
            </Top>
            {assignementType?.value === "on_ground" && (
                <Bottom>
                    <BranchesForm>
                        <SelectWithSearch
                            isEditable
                            isMulti
                            label="Select Branch"
                            options={allBranches}
                            handleFilter={(value) => fetchBranches(value)}
                            handleChange={(e) => setSelectedBranches(e)}
                            value={selectedBranches}
                            name="selectBranch"
                            placeholder="Select The Section.."
                        />
                    </BranchesForm>
                    <TagsContainer>
                        {selectedBranches.map((branch) => (
                            <Tag>
                                <span>{branch.label}</span>
                                <CloseIcon
                                    color="#004F85"
                                    onClick={() => handleRemoveBranch(branch)}
                                />
                            </Tag>
                        ))}
                    </TagsContainer>
                </Bottom>
            )}
            {error && <Error>{error}</Error>}
        </Container>
    );
}

export default AssignAdmins;
